import { render, staticRenderFns } from "./RegAsCollFromExamForm.vue?vue&type=template&id=2e823038&scoped=true&"
import script from "./RegAsCollFromExamForm.vue?vue&type=script&lang=js&"
export * from "./RegAsCollFromExamForm.vue?vue&type=script&lang=js&"
import style0 from "./RegAsCollFromExamForm.vue?vue&type=style&index=0&id=2e823038&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e823038",
  null
  
)

export default component.exports